import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicBaseQueryForWishListableItems } from './utils/webapi-base-query';
import { isServer } from 'tradera/utils/nextjs';
import type {
    SimilarItemsV2DetailParams,
    SimilarItemsV2ApiResponse
} from './types/webapi-discover-generated';
import qs from 'qs';

export const similarItemsV2Api = createApi({
    reducerPath: 'similarItemsV2Api',
    baseQuery: isomorphicBaseQueryForWishListableItems,
    endpoints: (builder) => ({
        getSimilarItemsV2: builder.query<
            SimilarItemsV2ApiResponse,
            SimilarItemsV2DetailParams
        >({
            query: ({
                itemId,
                shippingCountryCodeIso2,
                userLanguage,
                automaticTranslationPreferred
            }) => {
                const query = qs.stringify({
                    shippingCountryCodeIso2,
                    userLanguage,
                    automaticTranslationPreferred
                });
                const baseUrl = isServer ? '' : '/api/webapi';
                return `${baseUrl}/discover/similar-items-v2/${itemId}?${query}`;
            },
            extraOptions: {
                getWishListableItems: (response: SimilarItemsV2ApiResponse) =>
                    response.items
            }
        })
    })
});

export const { useGetSimilarItemsV2Query } = similarItemsV2Api;
